import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import TopHeader from '../template/TopHeader';
import MobileSubmenu from '../shared/MobileSubmenu';

class ClientsMobileNav extends Component {
    constructor(props) {
        super(props);
        this.state = {
            clientNav: [
                {
                    id: 'client-list',
                    url: '/clients',
                    title: 'Client List',
                    description: 'View and manage all clients',
                    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></svg>
                },
                {
                    id: 'data-sharing',
                    url: '/clients/data-sharing',
                    title: 'Data Sharing',
                    description: 'Manage client data sharing settings',
                    icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" /></svg>
                }
            ]
        };
    }

    handleNavClick = (url) => {
        this.props.history.push(url);
    };

    render() {
        return (
            <div className="h_n">
                <div className="body_container cm_bg_white">
                    <TopHeader title="Clients" headerButtonStatus={true} {...this.props} />
                    <MobileSubmenu items={this.state.clientNav} onNavigate={this.handleNavClick} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { ...state };
}

export default withRouter(connect(mapStateToProps)(ClientsMobileNav));
